import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  async function fetchBlogs() {
    setLoading(true);
    const { data, error } = await supabase
      .from('blogs')
      .select('*')
      .order('published_at', { ascending: false });

    if (error) console.error(error);
    else setBlogs(data || []);
    setLoading(false);
  }

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <div className="container">
          <h1>Endüstriyel Kesim Rehberi & Blog</h1>
          <p>Şerit testere kullanımı, bakımı ve sektörel yenilikler hakkında uzman görüşleri.</p>
        </div>
      </div>

      <div className="container" style={{ padding: '4rem 0' }}>
        {loading ? (
          <div className="text-center">Yükleniyor...</div>
        ) : blogs.length === 0 ? (
          <div className="text-center">Henüz yazı eklenmemiş.</div>
        ) : (
          <div className="blog-grid">
            {blogs.map(blog => (
              <Link key={blog.id} to={`/blog/${blog.slug}`} className="blog-card">
                <div className="blog-card-image">
                  <i className="fa-solid fa-file-lines"></i>
                </div>
                <div className="blog-card-content">
                  <span className="blog-date">{new Date(blog.published_at).toLocaleDateString('tr-TR')}</span>
                  <h3 className="blog-title">{blog.title}</h3>
                  <p className="blog-excerpt">{blog.excerpt}</p>
                  <span className="blog-read-more">Devamını Oku <i className="fa-solid fa-arrow-right"></i></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
